// extracted by mini-css-extract-plugin
export default {"wrapper":"PageContent_wrapper__vaFSh"};